
import React from 'react';

import { AcousticGuitarSlugs, BanjoSlugs, ElectricGuitarSlugs } from 'constants/inventory_filter_slugs';
import { NavLink, withRouter } from 'react-router-dom';

import Expandable from 'components/global/application/Expandable';
import FontAwesome from 'react-fontawesome';

import './InventoryNav.sass';

interface Props {
    location: Location;
}

interface IState {
    AcousticHidden: boolean;
    ElectricHidden: boolean;
    BanjosHidden: boolean;
}

class InventoryNav extends React.Component<Props, IState> {
    constructor(props: any) {
        super(props);

        this.state = {
            AcousticHidden: !this.checkForSlugInCurrentPath(AcousticGuitarSlugs),
            BanjosHidden: !this.checkForSlugInCurrentPath(BanjoSlugs),
            ElectricHidden: !this.checkForSlugInCurrentPath(ElectricGuitarSlugs),
        };
    }

    public componentDidUpdate(prevProps: any) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            this.setState({
                AcousticHidden: !this.checkForSlugInCurrentPath(AcousticGuitarSlugs),
                BanjosHidden: !this.checkForSlugInCurrentPath(BanjoSlugs),
                ElectricHidden: !this.checkForSlugInCurrentPath(ElectricGuitarSlugs),
            });
        }
    }

    public render() {
        return(
            <div className="InventoryNav-container">
                <span className="InventoryNav-header">Instruments &amp; Amps</span>
                <span className="InventoryNav-category">
                    <NavLink
                        to="/inventory/category/acoustic-guitars"
                        className="Acoustic-expander"
                    >
                        Acoustic Guitars
                        <FontAwesome
                            name={`chevron-${this.state.AcousticHidden ? 'right' : 'down'}`}
                            className="Acoustic-expander InventoryNav-arrow"
                        />
                    </NavLink>
                </span>
                <Expandable direction="vertical" expanded={!this.state.AcousticHidden} maxHeight="16em" className="InventoryNav-submenu">
                    <NavLink to="/inventory/category/martin-flattops" className="InventoryNav-submenu-item">Martin Flat-tops</NavLink>
                    <NavLink to="/inventory/category/gibson-and-epiphone-flattops" className="InventoryNav-submenu-item">Gibson and Epiphone Flat-tops</NavLink>
                    <NavLink to="/inventory/category/taylor-flat-tops" className="InventoryNav-submenu-item" id="Taylor Flat Tops">Taylor Flat-tops</NavLink>
                    <NavLink to="/inventory/category/acoustic-guitars?manufacturer=Collings" className="InventoryNav-submenu-item">Collings Flat-tops</NavLink>
                    <NavLink to="/inventory/category/acoustic-guitars?manufacturer=McPherson" className="InventoryNav-submenu-item">McPherson Flat-tops</NavLink>
                    <NavLink to="/inventory/category/acoustic-guitars?manufacturer=Cole%20Clark" className="InventoryNav-submenu-item">Cole Clark Flat-tops</NavLink>
                    <NavLink to="/inventory/category/miscellaneous-flattops" className="InventoryNav-submenu-item">Miscellaneous Flat-tops</NavLink>
                    <NavLink to="/inventory/category/archtop-acoustic-guitars" className="InventoryNav-submenu-item" id="Archtop Acoustic Guitars" >Archtop Guitars</NavLink>
                    <NavLink to="/inventory/category/classical-guitars" className="InventoryNav-submenu-item">Classical Guitars</NavLink>
                    <NavLink to="/inventory/category/resonator-guitars" className="InventoryNav-submenu-item">Resonator Guitars</NavLink>
                </Expandable>
                <span className="InventoryNav-category" >
                    <NavLink
                        to="/inventory/category/electric-guitars"
                        className="Electric-expander"
                    >
                        Electric Guitars
                        <FontAwesome
                            name={`chevron-${this.state.ElectricHidden ? 'right' : 'down'}`}
                            className="Electric-expander InventoryNav-arrow"
                        />
                    </NavLink>
                </span>
                <Expandable direction="vertical" maxHeight="11em" expanded={!this.state.ElectricHidden} className="InventoryNav-submenu">
                    <NavLink to="/inventory/category/fender-electrics" className="InventoryNav-submenu-item">Fender Electrics</NavLink>
                    <NavLink to="/inventory/category/gibson-solidbody-electrics" className="InventoryNav-submenu-item">Gibson Electrics</NavLink>
                    <NavLink to="/inventory/category/epiphone-electrics" className="InventoryNav-submenu-item">Epiphone Electrics</NavLink>
                    <NavLink to="/inventory/category/gretsch-electrics" className="InventoryNav-submenu-item">Gretsch Electrics</NavLink>
                    <NavLink to="/inventory/category/miscellaneous-solidbody-electrics" className="InventoryNav-submenu-item">Misc Solidbody Electrics</NavLink>
                    <NavLink to="/inventory/category/hollowbody-electrics" className="InventoryNav-submenu-item">Hollowbody Electrics</NavLink>
                    <NavLink to="/inventory/category/electric-steel-guitars" className="InventoryNav-submenu-item">Electric Steel Guitars</NavLink>
                </Expandable>
                <NavLink to="/inventory/category/mandolins-and-mandolin-family" className="InventoryNav-category">Mandolins &amp; Mandolin Family</NavLink>
                <span className="InventoryNav-category" >
                    <NavLink
                        to="/inventory/category/banjos"
                        className="Banjos-expander"
                    >
                        Banjos
                        <FontAwesome
                            name={`chevron-${this.state.BanjosHidden ? 'right' : 'down'}`}
                            className="Banjos-expander InventoryNav-arrow"
                        />
                    </NavLink>
                </span>
                <Expandable direction="vertical" maxHeight="3em" expanded={!this.state.BanjosHidden} className="InventoryNav-submenu">
                    <NavLink to="/inventory/category/five-string-banjos" className="InventoryNav-submenu-item">Five-string Banjos</NavLink>
                    <NavLink to="/inventory/category/tenor-plectrum-and-other-banjo-family" className="InventoryNav-submenu-item">Tenor, plectrum and other banjos</NavLink>
                </Expandable>
                <NavLink to="/inventory/category/ukuleles-taropatches-and-tiples" className="InventoryNav-category">Ukuleles, Taropatches, &amp; Tiples</NavLink>
                <NavLink to="/inventory/category/tenor-and-plectrum-guitars" className="InventoryNav-category">Tenor &amp; Plectrum Guitars</NavLink>
                <NavLink to="/inventory/category/miscellaneous-instruments" className="InventoryNav-category" id="Miscellaneous Instruments">Misc Instruments</NavLink>
                <NavLink to="/inventory/category/basses" className="InventoryNav-category">Basses</NavLink>
                <NavLink to="/inventory/category/amplifiers" className="InventoryNav-category">Amplifiers</NavLink>
                <NavLink to="/inventory/category/cases" className="InventoryNav-category">Cases</NavLink>
            </div>
        );
    }

    private checkForSlugInCurrentPath(haystack: string[]) {
        return this.checkForSlugInPath(haystack, this.props.location.pathname);
    }

    private checkForSlugInPath(haystack: string[], location: string) {
        return haystack.some((needle) => {
            return location.includes(needle);
        });
    }
}

const renderMobile: React.StatelessComponent = (props: any) => {
    return (null);
};

export default withRouter(InventoryNav);



// WEBPACK FOOTER //
// ./src/components/pages/inventory/InventoryNav.tsx